<template>
  <b-sidebar id="add-new-rol-sidebar" :visible="isAddNewRolSidebarActive" bg-variant="white" sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm" @change="(val) => $emit('update:is-add-new-rol-sidebar-active', val)" >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0"> {{$t('Add New Rol')}} </h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver" >
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm" >

          <!-- Full Name -->
          <validation-provider #default="validationContext" :name="$t('name')" rules="required" >
            <b-form-group :label="$t('Name')" label-for="name" >
              <b-form-input id="name" v-model="rolData.name" autofocus :state="getValidationState(validationContext)" trim placeholder="" />
              <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit" > {{$t('Add')}} </b-button>
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary" @click="hide" > {{$t('Cancel')}} </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewRolSidebarActive',
    event: 'update:is-add-new-rol-sidebar-active',
  },
  props: {
    isAddNewRolSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  setup(props, { emit }) {
    const blankRolData = {
      name: '',
    }

    const rolData = ref(JSON.parse(JSON.stringify(blankRolData)))
    const resetrolData = () => {
      rolData.value = JSON.parse(JSON.stringify(blankRolData))
    }

    const onSubmit = () => {
      store.dispatch('roles/addRol', rolData.value).then(() => {
        emit('refetch-data')
        emit('update:is-add-new-rol-sidebar-active', false)
      })
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetrolData)

    return {
      rolData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

#add-new-rol-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
